import React from 'react'
import Select from 'react-select'

const selectStyles = {
    container: styles => ({ ...styles,
        minWidth: '200px',

        ':after': {
            content: '""',
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            borderBottom: '1px solid rgba(0, 0, 0, 0.42)'
        }
    }),
    control: (styles, state) => {
        return {
            ...styles,
            minHeight: '29px',
            maxHeight: state.selectProps.maxHeight ? state.selectProps.maxHeight : '29px',
            overflowY: 'auto',
            border: 0,
            borderWidth: 0,
            borderRadius: 0,
            boxShadow: 'none',
            zIndex: 1,
            background: 'transparent',
            borderBottom: state.isFocused ?
            '2px solid #415dd4' :
            '2px solid transparent',

            ':hover': {
                borderBottom: state.isFocused ? '2px solid #415dd4' : '2px solid #4a4a4a'
            }
        }
    },
    indicatorsContainer: styles => ({ ...styles, display: 'none' }),
    valueContainer: styles => ({ ...styles, padding: '2px 0' }),
    menu: styles => ({ ...styles,
        boxShadow: '0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)',
		marginBottom: 0,
    	marginTop: 0
    }),
    option: (styles, { isFocused, isSelected }) => {
        return {
            ...styles,
            fontSize: '16px',
            lineHeight: '24px',
            padding: '6px 16px',
            backgroundColor: isSelected ? 'rgba(0, 0, 0, 0.04)' : isFocused ? 'rgba(0, 0, 0, 0.08)' : 'transparent',

            ':active': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
            },
			':hover': {
                backgroundColor: 'rgba(0, 0, 0, 0.04)'
            }
        }
    },
    menuPortal: styles => ({ ...styles, zIndex: 2 }),
	menuList: styles => ({
		...styles,
		paddingBottom: '8px',
    	paddingTop: '8px'
	}),
    multiValue: styles => ({ ...styles, borderRadius: '15px' }),
    multiValueLabel: styles => ({ ...styles, padding: '2.5px', fontSize: '12px', color: '#4a4a4a'}),
    input: styles => ({ ...styles, margin: '0 2px' }),
    multiValueRemove: styles => ({ ...styles,
        ':hover': {
            backgroundColor: 'initial',
            color: 'initial',
            cursor: 'pointer'
        }
    }),
}

export default ({defaultValue, value, options, onChange, maxHeight}) => (
    <Select
        defaultValue={defaultValue}
        value={value}
        isMulti
        options={options}
        placeholder=''
        styles={selectStyles}
        onChange={onChange}
        menuPosition='fixed'
        menuPlacement='auto'
        maxHeight={maxHeight}
    />
)
